export const COLLECTION_X_ROUTE = '(?<collectionCode>[a-z_0-9-]+)-collection-(?<collectionId>[0-9]+)';
export const COLLECTION_PAGE_X_ROUTE = '(?<collectionCode>[a-z0-9-]+)';
